import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'
import {colors} from './colors'

export const doc = documentComponent({
  name: 'BarGraph',
  description: 'A simple bar graph',
  categories: ['Graphs'],
  props: t.object({
    color: t.choice(Object.keys(colors)).optional(),
    className: t.string('className').optional(),
    values: t.array(t.array([t.string('x label'), t.number('y')])),
    maxY: t.number().optional()
  }),
  examples: {
    one: {
      props: {
        values: [['label one', 1], ['label two', 2], ['label three', 3]]
      },
      description: 'a few randoms'
    }
  },
  todo: []
})

